export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9760.85e5e7f0.jpg";